import React, { useEffect, useMemo, useState } from "react";
import { ChevronRight, Circle, MapPin, ArrowLeft, Pencil } from "lucide-react";
const VehicleFareCard = ({
  onNext,
  onBack,
  selectedVehicle,
  setSelectedVehicle,
  formData,
  setFormData,
}) => {

  const car="https://www.packky.com/images/Vechiles/four_wheeler.webp";
  const truck="https://www.packky.com/images/Vechiles/mini_truck.webp";
  const auto= "https://www.packky.com/images/Vechiles/three_wheeler.webp";
  const bike="https://www.packky.com/images/Vechiles/two_wheeler.webp";

  const vehicleNameMap = {
    "Two Wheeler": "Two Wheeler",
    "Three Wheeler": "Three Wheeler",
    "Four Wheeler": "Eeco",
    "Mini Truck": "Pickup Truck",
  };

  const vehicles = [
    {
      name: "Two Wheeler",
      img: bike,
      price: 76,
      toll: 5,
      detail: "20 kg • 40 cm • 1 mins",
      best: "Best for small parcels and quick delivery",
    },
    {
      name: "Three Wheeler",
      img: auto,
      price: 253,
      toll: 10,
      detail: "20 kg • 5 ft • 1 mins",
      best: "Best for medium goods and boxes",
    },
    {
      name: "Eeco",
      img: car,
      price: 260,
      toll: 10,
      detail: "20 kg • 3.4 ft • 1 mins",
      best: "Best for safe covered delivery",
    },
    {
      name: "Pickup Truck",
      img: truck,
      price: 289,
      toll: 15,
      detail: "20 kg • 5.5 ft • 1 mins",
      best: "Best for heavy and commercial goods",
    },
  ];

  const orderedVehicles = useMemo(() => {
    const selectedName =
      vehicleNameMap[selectedVehicle] || selectedVehicle || "Two Wheeler";

    const selected = vehicles.find((vehicle) => vehicle.name === selectedName);
    const others = vehicles.filter((vehicle) => vehicle.name !== selectedName);

    return selected ? [selected, ...others] : vehicles;
  }, [selectedVehicle]);

  const [activeVehicle, setActiveVehicle] = useState(
    orderedVehicles[0]?.name || "Two Wheeler",
  );

  const [showPayment, setShowPayment] = useState(false);
  const [isEditingAddress, setIsEditingAddress] = useState(false);

  useEffect(() => {
    setActiveVehicle(orderedVehicles[0]?.name || "Two Wheeler");
  }, [orderedVehicles]);

  const selectedVehicleData =
    orderedVehicles.find((vehicle) => vehicle.name === activeVehicle) ||
    orderedVehicles[0];

  const fare = useMemo(() => {
    const tripFare = Number(selectedVehicleData?.price || 0);
    const tollCharges = Number(selectedVehicleData?.toll || 0);
    const netFare = tripFare + tollCharges;

    return {
      tripFare,
      tollCharges,
      netFare,
      amountPayable: netFare,
    };
  }, [selectedVehicleData]);

  const handleVehicleSelect = (vehicleName) => {
    setActiveVehicle(vehicleName);

    if (setSelectedVehicle) {
      setSelectedVehicle(vehicleName);
    }
  };

  const handleAddressChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
 
  <section className="w-full px-3 pb-6 pt-8 sm:px-4 md:px-6 md:pt-12 lg:px-0 lg:pt-0">
 <div className="mx-auto mt-10 grid w-full max-w-[1020px] overflow-hidden rounded-[26px] border border-white/80 bg-white shadow-[0_22px_70px_rgba(15,23,42,0.16)] sm:mt-4 md:mt-10 lg:mt-[120px] lg:grid-cols-[57%_43%]">
      {/* LEFT */}
    <div className="order-2 flex flex-col bg-white px-4 py-6 sm:px-6 sm:py-8 md:px-8 lg:order-1 lg:px-7 lg:py-5">
          <div className=" w-full max-w-[580px]">
            {/* BACK */}
            <button
              type="button"
              onClick={onBack}
              className="mb-4 inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
            >
              <ArrowLeft size={17} />
              Back to Address
            </button>

            {/* DELIVERY INFO */}

            <div className="mb-4 rounded-lg border border-gray-200 bg-white">
              <div className="flex items-center justify-between border-b px-4 py-3">
                <h3 className="text-[18px] text-gray-800">Delivery Info</h3>

                <button
                  type="button"
                  onClick={() => setIsEditingAddress((prev) => !prev)}
                  className="inline-flex items-center gap-1 font-bold text-gray-800"
                >
                  <Pencil size={15} />
                  {isEditingAddress ? "Save" : "Edit Address"}
                </button>
              </div>

              <div className="relative min-h-[80px] px-4 py-3 pl-10">
                <div className="absolute left-5 top-5 h-[40px] border-l border-dashed border-gray-500"></div>

                <Circle
                  size={11}
                  className="absolute left-[15px] text-blue-500"
                />

                <MapPin
                  size={14}
                  className="absolute left-[13px] top-[60px] text-green-600"
                  fill="currentColor"
                />

                {isEditingAddress ? (
                  <div className="space-y-3">
                    <textarea
                      value={formData?.pickupAddress || ""}
                      onChange={(e) =>
                        handleAddressChange("pickupAddress", e.target.value)
                      }
                      placeholder="Enter pickup address"
                      rows={3}
                      className="w-full resize-none rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-700 outline-none focus:border-blue-400 focus:ring-4 focus:ring-blue-100"
                    />

                    <textarea
                      value={formData?.dropAddress || ""}
                      onChange={(e) =>
                        handleAddressChange("dropAddress", e.target.value)
                      }
                      placeholder="Enter drop address"
                      rows={3}
                      className="w-full resize-none rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-700 outline-none focus:border-blue-400 focus:ring-4 focus:ring-blue-100"
                    />
                  </div>
                ) : (
                  <div className="space-y-4">
                    <p className="break-words text-sm leading-6 text-gray-500">
                      {formData?.pickupAddress || "Pickup address not added"}
                    </p>

                    <p className="break-words text-sm leading-6 text-gray-500">
                      {formData?.dropAddress || "Drop address not added"}
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* CONTACT INFO */}
            <div className="mb-4 overflow-hidden rounded-lg border border-gray-200 bg-white">
              <h3 className="border-b px-4 py-3 text-[18px] text-gray-800">
                Contact Details
              </h3>

              <div className="grid grid-cols-1 gap-3 px-4 py-4 text-sm sm:grid-cols-2">
                <div>
                  <p className="text-gray-400">Sender</p>
                  <p className="font-semibold text-gray-800">
                    {formData?.senderName || "-"}
                  </p>
                  <p className="text-gray-500">
                    {formData?.senderMobile || "-"}
                  </p>
                </div>

                <div>
                  <p className="text-gray-400">Receiver</p>
                  <p className="font-semibold text-gray-800">
                    {formData?.receiverName || "-"}
                  </p>
                  <p className="text-gray-500">
                    {formData?.receiverMobile || "-"}
                  </p>
                </div>
              </div>
            </div>

            {/* FARE SUMMARY */}
            <div className="mb-4 overflow-hidden rounded-lg border border-gray-200 bg-white">
              <h3 className="border-b px-4 py-3 text-[18px] text-gray-800">
                Fare Summary
              </h3>

              <div className="space-y-2 px-4 py-4 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-500">Selected Vehicle</span>
                  <span className="font-bold text-gray-800">
                    {selectedVehicleData.name}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">Trip Fare</span>
                  <span className="font-bold text-gray-800">
                    ₹ {fare.tripFare.toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">
                    Toll Charges
                    <span className="ml-1 rounded-full bg-orange-100 px-1.5 py-0.5 text-[9px] text-orange-500">
                      include
                    </span>
                  </span>

                  <span className="font-bold text-gray-800">
                    ₹ {fare.tollCharges.toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">Net Fare</span>
                  <span className="font-bold text-gray-800">
                    ₹ {fare.netFare.toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between border-t pt-2">
                  <span className="font-bold text-gray-500">
                    Amount Payable
                  </span>
                  <span className="font-bold text-gray-800">
                    ₹ {fare.amountPayable.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>

            {/* PAYMENT */}
            <button
              type="button"
              onClick={() => setShowPayment(!showPayment)}
              className="mb-2 flex w-full items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-4 text-left font-bold text-gray-800"
            >
              Select Payment Mode
              <ChevronRight
                size={22}
                className={`transition ${showPayment ? "rotate-90" : ""}`}
              />
            </button>

            {showPayment && (
              <div className="mb-6 overflow-hidden rounded-lg border border-gray-200 bg-white">
                <button className="flex w-full items-center justify-between px-4 py-3 hover:bg-gray-50">
                  <span className="font-medium text-gray-700">UPI</span>
                  <span className="text-sm text-gray-400">
                    Google Pay / PhonePe
                  </span>
                </button>

                <button className="flex w-full items-center justify-between border-t px-4 py-3 hover:bg-gray-50">
                  <span className="font-medium text-gray-700">
                    Cash on Delivery
                  </span>
                  <span className="text-sm text-gray-400">
                    Pay after delivery
                  </span>
                </button>

                <button className="flex w-full items-center justify-between border-t px-4 py-3 hover:bg-gray-50">
                  <span className="font-medium text-gray-700">
                    Debit / Credit Card
                  </span>
                  <span className="text-sm text-gray-400">
                    Visa, Mastercard
                  </span>
                </button>
              </div>
            )}
          </div>

          {/* BOTTOM BUTTON */}
<div
  className={`w-full max-w-[580px] transition-all duration-300 ${
    showPayment ? "mt-0" : "mt-2"
  }`}
>
  <button
    type="button"
    onClick={onNext}
    className="w-full rounded-lg bg-[#1f2d3f] py-3 font-semibold text-white transition hover:opacity-90"
  >
    Driver is on the Way
  </button>
</div>
        </div>

        {/* RIGHT */}
       <div className="order-1 bg-[#fbf6e7] px-4 py-6 sm:px-6 sm:py-8 lg:order-2 lg:px-7 lg:py-5">
          <div className="mx-auto max-w-[420px]">
            <h4 className="mb-3 text-base font-bold text-gray-500">
              Recommended Vehicles
            </h4>

            <div className="space-y-4">
              {orderedVehicles.map((vehicle) => (
                <div
                  key={vehicle.name}
                  onClick={() => handleVehicleSelect(vehicle.name)}
                  className={`cursor-pointer overflow-hidden rounded-lg border bg-white transition ${
                    activeVehicle === vehicle.name
                      ? "border-orange-400 bg-orange-100"
                      : "border-gray-200 hover:border-orange-200"
                  }`}
                >
                  <div
                    className={`flex items-center justify-between px-4 py-4 ${
                      activeVehicle === vehicle.name
                        ? "bg-orange-100"
                        : "bg-white"
                    }`}
                  >
                    <div className="flex items-center gap-4">
                      <div className="flex h-16 w-16 items-center justify-center">
                        <img
                          src={vehicle.img}
                          alt={vehicle.name}
                          className="h-12 w-12 object-contain"
                        />
                      </div>

                      <div>
                        <h3 className="font-bold text-gray-800">
                          {vehicle.name}
                        </h3>

                        {activeVehicle === vehicle.name ? (
                          <div className="text-sm leading-5 text-gray-600">
                            <p>
                              <b>Weight:</b> Up to 20 kg
                            </p>
                            <p>
                              <b>Dimension:</b> H-40 cm x W-40 cm x L-40 cm
                            </p>
                          </div>
                        ) : (
                          <p className="text-sm text-gray-500">
                            {vehicle.detail}
                          </p>
                        )}
                      </div>
                    </div>

                    <h3 className="self-start text-[18px] font-bold text-gray-900 sm:self-center sm:text-[20px]">
                      ₹{vehicle.price}
                    </h3>
                  </div>

                  {activeVehicle === vehicle.name && (
                    <div className="border-t border-orange-300 bg-white px-4 py-3 text-sm text-gray-500">
                      {vehicle.best}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VehicleFareCard;